import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity } from "react-native";
import Swal from "sweetalert2";
import { Platform } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import SearchInventory from "./searchInventoryTypes";
import SearchItems from "./searchItems";
import colors from "../../constants/colors";
import SearchPackaging from "./searchPackagingMaterials";
//import { Audio } from 'expo-av';
import SearchInventoryLocations from "./searchInventoryLocations";
import SearchByProductCode from "./searchByProductCode";
import { searchPackagingMaterials, searchItems, searchInventoryTypes } from "../../actions/records";
import { getComponentSubmissionByDefaultLabel, getIosCellHeight, getComponentSubmit, getComponentByanotherComponentId, inputFocus, getComponentDefaultSubmit, sanitizeRecipeNumericInput } from "../../utils";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import { getIngredientLotsByName } from "../../actions/submissions";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";

var filterInterval;

/** TextInput expects string; submission JSON often has numeric quantity (e.g. [2]). */
function initialToControlledString(initial) {
  if (initial == null || initial === "") return "";
  if (typeof initial === "string") return initial;
  if (typeof initial === "number" || typeof initial === "boolean") return String(initial);
  return initial;
}

class Input extends Component {
  inputRef = createRef();
  inputTxtRef = createRef();
  constructor(props) {
    super(props);
    this.state = {
      value: initialToControlledString(this.props.initial),
      yieldValue: this.props.initial,
      qtyValue: this.props.initial,
      updated: initialToControlledString(this.props.initial),
      dialogVisible: false,
      height: 50,
      heightIOS: 27,
      scan: false,
      reset: false,
      options: this.props.inventoryLocations ? this.props.inventoryLocations : [],
      focused: false,
      scanerCanceled: false,
      focus: false
    };
  }
  componentDidUpdate(prevProps, prevState){
    if(prevState.scanerCanceled != this.state.scanerCanceled){
      //console.log('scanerCanceled333: ' + this.state.scanerCanceled)
    }
  }
  componentWillReceiveProps(nextProps) {
    const { defaultLabel, isRecipe, position } = this.props;
    if (nextProps.initial != this.props.initial && !(isRecipe && defaultLabel == "quantity")) {
      this.setState({ value: initialToControlledString(nextProps.initial) });
    }
    if (nextProps.initial != this.props.initial) {
      this.setState({ updated: initialToControlledString(nextProps.initial) });
    }
    if (nextProps.batchSizeChanged != this.props.batchSizeChanged && (isRecipe && defaultLabel == "quantity")) {
      this.setState({ value: getComponentDefaultSubmit(this.props.components, nextProps.submission, this.props.defaultLabel, this.props.id, this.props.position, this.props.defaultYield) });
    }
    if (nextProps?.resetInventorySearch) {
      if ((nextProps?.resetInventorySearch?.changed != this.props?.resetInventorySearch?.changed && nextProps?.resetInventorySearch?.position == this.props?.position && this.props?.isShipmentLog && this.props?.defaultLabel == 'item')) {
        this.setState({ value: initialToControlledString(nextProps.initial), reset: !this.state.reset });
      }
    }
    if (nextProps.inventoryLocations != this.props.inventoryLocations) {
      var options = nextProps.inventoryLocations;
      this.setState({ options: options });
    }
  }
  async handleBarCodeScanned(data) {
    const { onChange, id, isInventoryTransfer, isReceivingLog, isShipmentLog, defaultLabel, isRecipe, components, submission, position, section_id, handleFocusOnElement } = this.props;
    const { options } = this.state;
    this.setState({ scan: false }, async () => {
      setTimeout(() => {
        if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
      }, 100);
      //Activate sound for barcode
      //const { sound } = await Audio.Sound.createAsync(require('../../../assets/audio/scanner-audio.mp3'));
      //await sound.playAsync();

      if (data) {
        var scanned = data.trim();
        if ((isInventoryTransfer && (defaultLabel == "fromLocation" || defaultLabel == "toLocation")) || (isRecipe && defaultLabel == "location")) {
          var value = null;
          var scannedArray = scanned.split("-");
          if (scannedArray.length <= 1) {
            scannedArray = scanned.split("/");
          }
          if (scannedArray.length > 0) {
            scanned = "";
            scannedArray.map((location, idx) => {
              scanned += location.trim().replace(/ /g, "");
            });
          }
          options.map((location, idx) => {
            if(value != null)return;

            var completeLocation = "";
            if (location?.site?.locationName) {
              completeLocation += location.site.locationName.trim();
            }
            if (location?.zone?.locationName) {
              completeLocation += location.zone.locationName.trim();
            }
            if (location?.aisle?.locationName) {
              completeLocation += location.aisle.locationName.trim();
            }
            if (location?.rackBay?.locationName) {
              completeLocation += location.rackBay.locationName.trim();
            }
            if (location?.shelfLevel?.locationName) {
              completeLocation += location.shelfLevel.locationName.trim();
            }
            if (location?.bin?.locationName) {
              completeLocation += location.bin.locationName.trim();
            }
            completeLocation = completeLocation.trim().replace(/ /g, "");
            completeLocation = completeLocation.replace(/[/-]+/g, "");
            //console.log("completeLocation: " + idx + completeLocation.toLowerCase())
            if (scanned.toLowerCase() == completeLocation.toLowerCase()) {
              value = [location];
            }

            return completeLocation;
          });
          //console.log("value: " + JSON.stringify(value));
          //console.log("scanned: " + scanned.toLowerCase());

          if (value) {
            this.setState({ value: value });
            onChange(id, value);
          } else {
            if (defaultLabel == "toLocation") {
              Swal.fire({
                text: "This location does not exist. A new main location will be created automatically, but it must be reorganized by an administrator. This is not recommended. Do you want to proceed?",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showCancelButton: true,
                confirmButtonColor: colors.orange,
                backdrop: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.setState({ updated: data });
                  onChange(id, data);
                }
              });
            } else {
              this.alertConfirm("Sorry, the scanned location does not exist on inventory", "Accept");
            }
          }
          return;
        } else if (((isInventoryTransfer || isReceivingLog || isShipmentLog) && (defaultLabel == "rawMaterialProductCode" || defaultLabel == "packagingProductCode" || defaultLabel == "fgProductCode" || defaultLabel == "wipProductCode"))) {
          this.searchItems(data, defaultLabel, (itemSelected) => {

            if (itemSelected) {
              if (isShipmentLog) {
                var newItem = JSON.parse(JSON.stringify(itemSelected));
                newItem.lotSelected = ["default_lot"];
                onChange(id, scanned, newItem);
              } else {
                onChange(id, scanned, itemSelected);
              }
              this.setState({ value: scanned });
            } else {
              var submit = "";
              if (isInventoryTransfer) {
                if (defaultLabel == "rawMaterialProductCode") {
                  submit = getComponentSubmissionByDefaultLabel("itemName", components, submission, section_id, position);
                } else {
                  submit = getComponentSubmissionByDefaultLabel("item", components, submission, section_id, position);
                }
              } else if (isReceivingLog || isShipmentLog) {
                if (defaultLabel == "rawMaterialProductCode") {
                  submit = getComponentSubmissionByDefaultLabel("ingredient", components, submission, section_id, position);
                } else if (defaultLabel == "packagingProductCode") {
                  submit = getComponentSubmissionByDefaultLabel("packagingMaterial", components, submission, section_id, position);
                }
              }
              if (submit != "") {
                this.setState({ value: scanned });
                onChange(id, scanned, null);
              } else {
                this.alertConfirm("This product code is not in the system. Please search for the product manually by item name, then try scanning again.", "Accept");
              }
            }

          });
          return;
        }

        this.setState({ value: scanned });
        onChange(id, scanned, null);
      }
    });
  }
  async searchItems(val, type, callback) {
    const { inventoryTypes } = this.props;
    var result = null;
    if (val) {
      switch (type) {
        case "rawMaterialProductCode":
          var itemsData = { page: 1, productCode: val };
          this.props.searchItems(itemsData, (res) => {
            if (res?.items?.length > 0) {
              result = res.items.find((item) => item.productCode == val);
              if (callback) callback(result);
            } else {
              if (callback) callback(null);
            }
          });
          break;
        case "packagingProductCode":
          var itemsData = { page: 1, productCode: val };
          this.props.searchPackagingMaterials(itemsData, (res) => {
            if (res?.packagingMaterials?.length > 0) {
              result = res.packagingMaterials.find((item) => item.productCode == val);
              if (callback) callback(result);
            } else {
              if (callback) callback(null);
            }
          });
          break;
        case "fgProductCode":
          this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Finished goods", fromApp: true }, (res) => {
            if (res?.inventoryTypes?.length > 0) {
              result = res.inventoryTypes.find((item) => item.productCode == val);
              if (callback) callback(result);
            } else {
              if (callback) callback(null);
            }
          });
          break;
        case "wipProductCode":
          this.props.searchInventoryTypes({ page: 1, productCode: val, type: "Work in progress", fromApp: true }, (res) => {
            if (res?.inventoryTypes?.length > 0) {
              result = res.inventoryTypes.find((item) => item.productCode == val);
              if (callback) callback(result);
            } else {
              if (callback) callback(null);
            }
          });
          break;
      }
    }
  }

  serchInInventoryTypes(value, type, inventoryTypes, subtype) {
    var type = inventoryTypes.find(inventory => {
      if (inventory?.productCode) {
        var productCode = inventory.productCode.toLowerCase();
        if (subtype == "types") {
          return inventory.inventoryType == type && productCode == value.toLowerCase();
        } else {
          return productCode == value.toLowerCase();
        }
      } else {
        return false;
      }
    });
    return type;
  }
  getMinChar(width) {
    var chrs = 26;
    switch (width) {
      case "small":
        chrs = 13
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return chrs;
  }
  getFirstDiv(width) {
    var val = 19;
    switch (width) {
      case "small":
        val = 11
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return val;
  }
  getSecondDiv(width) {
    var val = 28;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 19
        break;
      case "large":
        val = 26;
        break;
    }
    return val;
  }
  getThirdDiv(width) {
    var val = 31;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 24
        break;
      case "large":
        break;
    }
    return val;
  }
  onSelectItem(val, type, item) {
    const { onChange, id, handleFocusOnElement } = this.props;
    if (type) {
      if (type == 'lot') {
        this.setState({ value: val?.lot });
      } else {
        if(val?.item){
          this.setState({ value: val?.item });
        }else{
          this.setState({ value: val });
        }
      }
    } else {
      this.setState({ value: val });
    }
    if (item) {
      onChange(id, val, item);
    } else {
      onChange(id, val);
    }
    
    //setTimeout(() => {
    //  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
    //}, 100);
  }

  batchSizeAlert() {
    const { onChange, id } = this.props;
    const { yieldValue, value } = this.state;
    clearInterval(filterInterval);
    Swal.fire({
      text: "Are you sure you want to increase/decrease the ingredients and yield of this recipe?.",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ yieldValue: value });
        onChange(id, value);
      } else {
        this.setState({ value: yieldValue });
      }
    });
  }
  qtyAlert(totalAmout, newQty, newLineLotcode){
    const { onChange, id, addRmLine } = this.props;
    const { qtyValue, value } = this.state;
    var name = "";
    if(typeof newLineLotcode[0] == "object"){
      name = newLineLotcode[0]?.lot ? newLineLotcode[0]?.lot : "FIFO";
    }else{
      name = "FIFO";
    }
    if(filterInterval)clearInterval(filterInterval);
    Swal.fire({
      text: 'The selected lot code does not have enough quantity to fulfill the required amount. The remaining quantity will be automatically taken from lot code "' + name.trim() + '" and added to the table.',
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ value: totalAmout, qtyValue: totalAmout });
        onChange(id, totalAmout);
        if (addRmLine) addRmLine(newQty, newLineLotcode);
        if (filterInterval) clearInterval(filterInterval);
      } else {
        this.setState({ value: qtyValue });
        onChange(id, qtyValue);
        if (filterInterval) clearInterval(filterInterval);
      }
    });
  }
  validateItemStockQty(val) {
    const { id, onChange, defaultLabel, components, submission, inventoryTypes, position } = this.props;
    var valid = true;
    var qtyComponent = components.find(component => component.id == id);
    if (qtyComponent) {
      var lotCodeLabel = defaultLabel == "quantityFinishedGoods" ? "lotcode_finished" : "lotcode_wip";
      var nameComponent = components.find(component => component.section_id == qtyComponent.section_id && component?.defaultLabel == "item");
      if (nameComponent) {
        var itemName = submission[nameComponent.id][position];
        var names = submission[nameComponent.id];
        var totalQuantity = 0;
        var selectedQuantity = 0;
        //Calculate total quantity
        var item = inventoryTypes.find(inv => inv.item == itemName);
        if (item) {
          item.items.map((itm) => {
            if (itm?.historial) {
              itm.historial.map((historial) => {
                if (historial?.amount > 0) {
                  totalQuantity += historial?.amount;
                }
              });
            }
          });
        } else {
          this.setState({ value: val });
          onChange(id, val);
          return;
        }
        //Calculate selected quantity
        names.map((name, idx) => {
          if (itemName == name && idx != position) {
            var selectedQty = parseFloat(submission[id][idx]);
            if (selectedQty > 0) {
              selectedQuantity += selectedQty;
            }
          }
        });
        var total = parseFloat(val) + selectedQuantity;
        if (total > totalQuantity) {
          valid = false;
        }
      }
    }
    if (valid) {
      this.setState({ value: val });
      onChange(id, val);
    } else {
      this.alertConfirm("The amount available in this lot is insuficient", "Accept");
    }
  }
  alertConfirm(msg, conf) {
    Swal.fire({
      text: msg,
      confirmButtonText: conf,
      confirmButtonColor: "#0B4DA0",
      backdrop: false,
    });
  }
  validDecimals(val) {
    var decimals = val.split('.');
    var valid = true;
    if (decimals[1]) {
      if (decimals[1]?.length > 3) {
        valid = false;
      }
    }
    if (decimals.length > 2) valid = false;
    return valid;
  }
  checkForDefaulItems() {
    const { isRecipe, defaultLabel, submission, components, id, position } = this.props;
    var defaultItems = false;
    if (isRecipe && defaultLabel == "location") {
      var comp = components.find(component => component.id == id)
      if (comp) {
        var itemComponent = components.find(component => component.section_id == comp.section_id && component.defaultLabel == "ingredient");
        if (itemComponent) {
          var sub = "";
          if (position || position == 0) {
            sub = submission[itemComponent.id][position];
          } else {
            sub = submission[itemComponent.id];
          }
          if (sub && typeof sub == "string") {
            sub = sub.trim();
            sub = sub.toLocaleLowerCase();
            if (sub == "water") {
              defaultItems = true;
            }
          }
        }
      }
    }

    return defaultItems;
  }
  showScanner(value) {
    //console.log('scane: ' + value)
    //console.log('scanerCanceled333: ', (value ? false : this.state.scanerCanceled))
    this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled, focus: value ? false : this.state.focus });
  }
  renderInputView(){
    const { value } = this.state;
    const { width } = this.props;
    return <View style={{
      ...styles.input,
      borderColor: "#e7e7e7",
      borderRadius: 5,
      borderWidth: 1,
      color: "#424242",
      fontSize: 20,
      fontWeight: "400",
      paddingLeft: 0,
      paddingTop: 5,
      flex:1,
      height:
        Platform.OS === 'ios' ?
          this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
          this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
          fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
    }}><Text style={{ fontSize: 20, fontWeight: "400", color: "#424242", paddingLeft: 10, fontFamily: "Roboto",}}>{value}</Text></View>;
  }
  checkRmLotcodeQty(submission, components, defaultLabel ,componentId, position, value){
    var lotSelected = getComponentSubmit(submission, components, defaultLabel, componentId, position);
    var name = getComponentSubmit(submission, components, "ingredient", componentId, position);
    if(filterInterval)clearInterval(filterInterval);
    if(lotSelected){
      this.props.getIngredientLotsByName({ name, type: "ingredient" }, (res) => {

        var totalAmount = parseFloat(lotSelected[0].totalAmount) ? lotSelected[0].totalAmount : 0;
        var floatValue = parseFloat(value);
        
        if(lotSelected == "default_lot"){
          totalAmount = 0;
          if (res?.lots?.length) {
            res.lots.map((lotcode)=>{
              if(lotcode?.totalAmount){
                totalAmount += lotcode.totalAmount;
              }
            });
          }
        }
        
        if(floatValue <= totalAmount){
          this.props.onChange(this.props.id, value);
        }else {
          var newQty = floatValue - totalAmount;
          newQty = newQty.toFixed(3);
            if (res?.lots?.length) {
              var newLineLotcode = ["default_lot"];
              res.lots.map((lotcode)=>{
                if(lotcode.lot != lotSelected[0]?.lot && newQty <= lotcode.totalAmount && newLineLotcode[0] == "default_lot"){
                  newLineLotcode = [lotcode];
                }
              });
              this.qtyAlert(totalAmount.toFixed(3).toString(), newQty, newLineLotcode);
            }
        }
      });

    }
    
  }
  getUnits(defaultLabel, id, components, submission, position){
  
    var units = "";
    var unitsComponent = null;
    if (this.isQuantityComponent(defaultLabel)) {
      unitsComponent = getComponentByanotherComponentId(id, "units", components);
      if(!unitsComponent && this.props.isShipmentLog){
        unitsComponent = getComponentByanotherComponentId(id, "unitsWIP", components);
      }
    }else if(defaultLabel == "amount"){
      unitsComponent = getComponentByanotherComponentId(id, "yieldUnits", components);
    }
    else if(defaultLabel == "yield"){
      unitsComponent = components.find((component) => component?.defaultLabel == "yieldUnits");
      //units = "Kg";
    }
    if(unitsComponent){
      units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent?.section_id, position);
    }
    if(typeof units == "object" && !position)units = units[0];
    return units;
  }
  isQuantityComponent(defaultLabel){
    return defaultLabel == "quantity" || defaultLabel == "quantityIngredient" || defaultLabel == "quantityFinishedGoods" || defaultLabel == "quantityWIP" || defaultLabel == "quantityPackaging";
  }
  isNumericInput(defaultLabel, isQuantityComponent) {
    return defaultLabel == "yield" || defaultLabel == "amount" || isQuantityComponent;
  }
  getKeyboardType(defaultLabel, isQuantityComponent) {
    const isNumericInput = this.isNumericInput(defaultLabel, isQuantityComponent);
    if (isNumericInput) {
      return Platform.OS == "ios" ? "decimal-pad" : "numeric";
    }
    return Platform.OS == "ios" ? "default" : "text";
  }
  showScannerInput(){
    const { isInventoryReceivingForm } = this.props;

    if(isInventoryReceivingForm)return;
    if(!this.state.scanerCanceled){
      this.showScanner(true);
    }else this.setState({ scanerCanceled: false });
  }
  render() {
    const { scan, reset, options, updated } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, showScanner, width ,openIssue, defaultComponent, handleFocusOnElement, showInventorySearch, showItemsSearch, showPackagingSearch, isRecipe, defaultLabel, showFinishedGoodsSearch, showWorkInProgressSearch, itemInvoice_id, submission, position, isShipmentLog, searchClients, searchSuppliers, isInventoryTransfer, openDropDown, backgroundColor, isDropDownOpened, isReceivingLog, showProductCodeSearch, inventoryTypes, closeSearch, hideInput, setFocusedInput, focused, components, scannerInput, isInventoryReceivingForm, setShowTextBar, openBarCodeScanner, setFormScroll, resetDropDown } = this.props;
    const type = defaultLabel == "lotcode_finished" ? "Finished goods" : defaultLabel == "lotcode_wip" ? "Work in progress" : "";
    const isQuantityComponent = this.isQuantityComponent(defaultLabel);
    const isNumericInput = this.isNumericInput(defaultLabel, isQuantityComponent);
    var units = (isQuantityComponent || (defaultLabel == "amount" || defaultLabel == "yield")) ? this.getUnits(defaultLabel, id, components, submission, position) : "";
    var value = this.state.value;
    if(isRecipe && defaultLabel == "quantity" && value){
      value = getComponentDefaultSubmit(components, submission, defaultLabel, id, position, this.props.defaultYield);
    }
    return (
      <View ref={this.inputRef}>
          {scan ?
            <View style={{...styles.container,
              paddingTop: this.props.width ? 0 : 5
            }}>
              <BarcodeScannerComponent
                onBarCodeScanned={(e) => this.handleBarCodeScanned(e)}
                closeScanner={() => {
                  if(scannerInput && showScanner){
                    this.setState({ scanerCanceled: true, scan: false }, ()=>{
                      setTimeout(() => {
                        if(this.inputTxtRef.current){
                          inputFocus(this.inputTxtRef);
                        }
                        //this.setState({ scanerCanceled: false });
                        this.setState({ focus: true });
                      }, 500);
                    })
                  }
                }}
                style={styles.absoluteFillObject}
              />
            </View>
          :
          <>
            {(this.state.dialogVisible && !width) &&
              <View style={{...styles.container,
                paddingTop: width ? 0 : 5,
                height: 150
              }}>
                <NewIssue
                  visible={this.state.dialogVisible}
                  id={id}
                  label={label}
                  onSubmitIssue={onSubmitIssue}
                  handleClose={() => this.setState({ dialogVisible: false })}
                />
              </View>
            }
            {!this.state.dialogVisible &&
              <View style={{...styles.container,
                paddingTop: width ? 0 : (isRecipe && (defaultLabel == "yield" || defaultLabel == "amount")) ? 20 : 5,
                paddingBottom: showScanner ? 10 : 0,
                flexDirection: (isRecipe && defaultLabel == "yield") ? "row" : "column",
                padding: (isRecipe && (defaultLabel == "yield")) ? 10 : 0,
                marginTop: (isRecipe && (defaultLabel == "amount")) ? Platform.OS == "ios" ? 13 : 14 : 0,
                //paddingBottom: (isRecipe && defaultLabel == "yield") ? 10 : 0,
                flex: 1
              }}>
                {
                  label ?
                  (isRecipe && defaultLabel == "yield") ? 
                    <View style={{ flex: 1, justifyContent: 'center' }}>
                      <Text style={{...styles.label, fontWeight: '700', color: 'black', marginBottom: 5}}>{this.props.label}</Text>
                      <Text style={{...styles.label, fontSize: 12, color: 'black' }}>Enter the actual batch size</Text>
                    </View>
                  : <Text style={{...styles.label, fontWeight: defaultLabel == "productCode" ? '700' : '300', color: defaultLabel == "productCode" ? 'black' :'#939598' }}>{this.props.label}</Text> : null
                }
                {
                  (isIssuable && isCompleted) &&
                  <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
                    if (width) {
                      openIssue();
                    } else {
                      this.setState({ dialogVisible: true });
                    }
                  }}>
                    <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
                  </TouchableOpacity>
                }
                <View style={{...styles.inputContainer }}>
                  <View style={{...styles.inputC, 
                      borderWidth: isRecipe && (defaultLabel == "yield" || defaultLabel == "amount") ? 1 : 0,
                      borderRadius: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
                      paddingInline: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 5 : 0,
                      marginInline: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
                      paddingVertical: isRecipe ? Platform.OS == "ios" ? 8 : 0 : 0,
                      borderColor: colors.orange,
                    }}>
                    {
                      showItemsSearch &&
                      <SearchItems onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'ingredient', item)} initial={value} isShipmentLog={isShipmentLog} isInventoryTransfer={isInventoryTransfer} placeholder="Enter text to search items" width={width} handleFocusOnElement={handleFocusOnElement} isReceivingLog={isReceivingLog} defaultLabel={defaultLabel} isRecipe={isRecipe} isInventoryReceivingForm={isInventoryReceivingForm} setShowTextBar={setShowTextBar}  resetDropDown={resetDropDown}/>
                    }
                    {
                      showInventorySearch &&
                      <SearchInventory onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'lot', item)} initial={value} type={type} searchBy={'lot'} placeholder="Enter a lot to search" width={width} handleFocusOnElement={handleFocusOnElement} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} setShowTextBar={setShowTextBar} resetDropDown={resetDropDown}/>
                    }
                    {
                      showPackagingSearch &&
                      <SearchPackaging onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, null, item)} initial={value} placeholder="Enter a packaging material to search" width={width} handleFocusOnElement={handleFocusOnElement} isInventoryTransfer={isInventoryTransfer} isRecipe={isRecipe} defaultLabel={defaultLabel} isInventoryReceivingForm={isInventoryReceivingForm} setShowTextBar={setShowTextBar} isShipmentLog={isShipmentLog} resetDropDown={resetDropDown}/>
                    }
                    {
                      showFinishedGoodsSearch &&
                      <SearchInventory onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'item', item)} initial={value} type={'Finished goods'} isInventoryTransfer={isInventoryTransfer} searchBy={'item'} itemInvoice_id={itemInvoice_id} submission={submission} position={position} placeholder="Enter an item to search" width={width} handleFocusOnElement={handleFocusOnElement} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} isInventoryReceivingForm={isInventoryReceivingForm} setShowTextBar={setShowTextBar} resetDropDown={resetDropDown}/>
                    }
                    {
                      showWorkInProgressSearch &&
                      <SearchInventory onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'item', item)} initial={value} type={'Work in progress'} isInventoryTransfer={isInventoryTransfer} searchBy={'item'} itemInvoice_id={itemInvoice_id} submission={submission} position={position} placeholder="Enter an item to search" width={width} handleFocusOnElement={handleFocusOnElement} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} isInventoryReceivingForm={isInventoryReceivingForm} setShowTextBar={setShowTextBar} resetDropDown={resetDropDown}/>
                    }
                    {
                      searchClients &&
                      <SearchItems onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} customers={true} placeholder={"Enter text to search customers"} isRecipe={isRecipe} setShowTextBar={setShowTextBar} resetDropDown={resetDropDown}/>
                    }
                    {
                      searchSuppliers &&
                      <SearchItems onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} suppliers={true} placeholder={"Enter text to search suppliers"} isRecipe={isRecipe} setShowTextBar={setShowTextBar} resetDropDown={resetDropDown}/>
                    }
                    {
                      (isInventoryTransfer && (defaultLabel == "fromLocation" || defaultLabel == "toLocation")) &&
                      <SearchInventoryLocations onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner){
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} updated={updated} options={options} placeholder={"Enter text to search locations"} handleFocusOnElement={handleFocusOnElement} width={width} isRecipe={false} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} defaultLabel={defaultLabel} setShowTextBar={setShowTextBar} id={id} position={position} onChange={onChange} />
                    }
                    {
                      (isRecipe && (defaultLabel == "location") && !this.checkForDefaulItems()) &&
                      <SearchInventoryLocations onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if(scannerInput && showScanner){
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} options={options} placeholder={"Enter text to search locations"} width={width} isRecipe={isRecipe} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} resetDropDown={resetDropDown} defaultLabel={defaultLabel} setShowTextBar={setShowTextBar} id={id} position={position} />
                    }
                    {
                      showProductCodeSearch &&
                      <SearchByProductCode onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        //if(scannerInput && showScanner)this.showScannerInput();

                      }} focus={this.state.focus} closeSearch={closeSearch} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, null, item)} initial={value} placeholder={"Enter text to search items"} width={width} type={defaultLabel} inventoryTypes={inventoryTypes} isShipmentLog={isShipmentLog} isInventoryTransfer={isInventoryTransfer} isInventoryReceivingForm={isInventoryReceivingForm} id={id} position={position} handleFocusOnElement={handleFocusOnElement} setShowTextBar={setShowTextBar} openBarCodeScanner={openBarCodeScanner} isReceivingLog={isReceivingLog} scannerInput={scannerInput} showScanner={showScanner} setFormScroll={setFormScroll} resetDropDown={resetDropDown}/>
                    }
                    {
                      !showProductCodeSearch && !showItemsSearch && !showInventorySearch && !showPackagingSearch && !showFinishedGoodsSearch && !showWorkInProgressSearch && !searchClients && !searchSuppliers && !(isInventoryTransfer && (defaultLabel == "fromLocation" || defaultLabel == "toLocation")) && !(isRecipe && (defaultLabel == "location")) ?
                       hideInput ? <View style={{ flexDirection: 'row', paddingTop: (isRecipe && defaultLabel == "yield") ? 5 : 0}}>{this.renderInputView()}</View> :
                       <View style={{ flexDirection: 'row', paddingTop: (isRecipe && defaultLabel == "yield") ? 5 : 0}}>
                       <TextInput
                        {...getNoAutofillProps()}
                        value={value}
                        ref={noAutofillRef(this.inputTxtRef)}
                        editable={!defaultComponent}
                        keyboardType={this.getKeyboardType(defaultLabel, isQuantityComponent)}
                        inputMode={isNumericInput ? "decimal" : "text"}
                        scrollEnabled={isRecipe ? false : true}
                        //onBlur={() => {
                        //  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        //}}
                        onFocus={() => {
                          setTimeout(() => {
                            if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                            setTimeout(() => {
                              if(isRecipe){
                                if(setFocusedInput)setFocusedInput();
                              }
                            }, 200);
                          }, 200);
                          if(scannerInput && showScanner && defaultLabel != "preparationInstructions")this.showScannerInput();
                          /* Clear KeyboardBar when focus moves to a generic text field (not lotcode/productCode) on mobile web or Android native */
                          if (setShowTextBar && (isMobileWeb() || Platform.OS === "android")) {
                            setShowTextBar(null, null, null, null, null, null, null, false);
                          }
                        }}
                        style={{
                          ...styles.input,
                          borderColor: focused && defaultLabel == "quantity" ? colors.add : defaultLabel == "productCode" ? colors.orange : "#e7e7e7",
                          borderRadius: 5,
                          borderWidth: focused && (isInventoryReceivingForm && isQuantityComponent) ? 2 : ((isRecipe && defaultLabel == "yield") || (isRecipe && width && defaultLabel != "preparationInstructions")) ? 0 : 1,
                          color: isRecipe && (defaultLabel == "yield" || defaultLabel == "amount") ? colors.orange : "#424242",
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          fontSize: isInventoryReceivingForm ? 16 : 20,
                          //padding: isRecipe ? 5 : 10,
                          flex: isInventoryReceivingForm ? Platform.OS == "ios" ? 6 : 7 : 1,
                          textAlign: isInventoryReceivingForm && (isQuantityComponent || defaultLabel == "yield" || defaultLabel == "amount") ? 'center' : 'left',
                          height:
                            isMobileWeb() ?
                              this.state.value !== '' ? this.state.heightIOS * getIosCellHeight((isInventoryReceivingForm && isQuantityComponent) ? "extraminiQty" : width, value) : this.state.heightIOS * getIosCellHeight((isInventoryReceivingForm && isQuantityComponent) ? "extraminiQty" : width, this.props.placeholder) :
                              'auto',
                          fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                          padding: 5,
                          paddingLeft: isInventoryReceivingForm && isQuantityComponent ? 0 :10,
                          width: (isInventoryReceivingForm && isNumericInput) ? '50%' : 'auto',

                        }}
                        multiline={!isNumericInput}
                        placeholder={this.props.placeholder}
                        placeholderTextColor={'rgb(0, 47, 108)'}
                        onChangeText={(val) => {
                          if (!defaultComponent && (val != value)) {
                            if (isRecipe && (defaultLabel == "yield" || defaultLabel == "quantity")) {
                              var formated = sanitizeRecipeNumericInput(val.trim());
                              if (formated == '') {
                                clearInterval(filterInterval);
                                if(defaultLabel == "yield"){
                                  this.setState({ value: formated });
                                }else if(defaultLabel == "quantity"){
                                  this.setState({ value: formated, qtyValue: formated });
                                  onChange(id, formated);
                                }
                              } else {
                                this.setState({ value: formated }, () =>{
                                  clearInterval(filterInterval);
                                  if(defaultLabel == "yield"){
                                    filterInterval = setInterval(() => this.batchSizeAlert(), 2500);
                                    return;
                                  }else if(defaultLabel == "quantity"){
                                    filterInterval = setInterval(() => this.checkRmLotcodeQty(submission, components, "lotcode", id, position, formated), 2500);
                                  }
                                });
                              }
                            } else {
                              //if (isShipmentLog && (defaultLabel == "quantityFinishedGoods" || defaultLabel == "quantityWIP")) {
                              //  this.validateItemStockQty(val);
                              //} else {
                              if (isInventoryTransfer && defaultLabel == "quantity") {
                                if (!this.validDecimals(val)) return;
                              }else if(isNumericInput){
                                val = sanitizeRecipeNumericInput(val);
                              }

                              this.setState({ value: val });
                              if(isQuantityComponent){
                                onChange(id, val, null, true);
                              }
                              onChange(id, val);
                              //}
                            }
                          }

                        }}
                      />
                      {(isInventoryReceivingForm && units) && <View style={{...styles.unitsContainer, flex: defaultLabel == "yield" || defaultLabel == "amount" ? 6 : 4}}><Text style={{ textAlign: 'center', wordBreak: 'break-all'}}>{(defaultLabel == "yield" || defaultLabel == "amount") ? '('+units+')' : units}</Text></View>}
                      </View> : null
                    }
                  </View>
                  {
                    showScanner && !scannerInput &&
                    <View style={styles.btnC}>
                      <TouchableOpacity style={styles.btnScan}
                        disabled={defaultComponent}
                        onPress={() => {
                          this.showScanner(true);
                          setTimeout(() => {
                            if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                          }, 300);
                        }}
                      >
                        <Text style={styles.txtScan}>
                          Scan
                        </Text>
                      </TouchableOpacity>
                    </View>
                  }
                </View>
              </View>
            }

          </>}
      </View>
    );
  }
}
export default connect((state, ownProps = {}) => ({
  company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
  searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
    dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
  searchPackagingMaterials: (data, callback) =>
    dispatch(searchPackagingMaterials(data, callback)),
  searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
    dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
  getIngredientLotsByName: (data, callback) => {
    dispatch(getIngredientLotsByName(data, callback))
  },
  dispatch: dispatch,
}))(Input);

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    // paddingBottom: 10,
    // paddingHorizontal: 10,
    paddingTop: 5,
  },
  input: {
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderWidth: 1,
    color: "#424242",
    fontFamily: "Roboto",
    fontSize: 25,
    fontWeight: "400",
    paddingLeft: 10,
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  inputContainer: {
    flex: 1,
    flexDirection: "column",
  },
  inputC: {
    flex: 3,
  },
  btnC: {
    flex: 1
  },
  btnScan: {
    textAlign: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
    height: "100%",
    borderRadius: 5,
    marginTop: 10
  },
  txtScan: {
    textAlign: "center",
    justifyContent: "center",
    color: "white"
  },
  absoluteFillObject: {
    height: 400,
    width: "100%",
  },
  btnCancel: {
    backgroundColor: colors.orange,
    justifyContent: "center",
    borderRadius: 5,
    marginTop: 10,

  },
  btnCancelText: {
    justifyContent: "center",
    textAlign: "center",
    padding: 5,
    color: "white"
  },
  unitsContainer:{
    flex: 4, justifyContent: 'center', alignContent: 'center', paddingLeft: 3
  }
});
